import generate from 'nanoid/generate';
import range from 'lodash/range';

export default (length) => generate(range(26).map((i) => String.fromCharCode(65 + i)), length);
